<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user custom-user-dropdown"
  >
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p
          class="user-name font-weight-bolder mb-0 user-name-truncate"
          :title="displayName"
        >
          {{ displayName }}
        </p>
      </div>
      <b-avatar
        size="40"
        :src="avatarUrl"
        :text="avatarInitials"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
      />
    </template>

    <div
      v-if="isSideDataLoading"
      style="height: 50px"
      class="d-flex justify-content-center align-items-center"
    >
      <b-spinner label="Loading..." />
    </div>
    <b-dropdown-item
      v-else
      link-class="d-flex align-items-center user-profile-head"
      class="align-items-center w-100"
    >
      <div class="w-100">
        <div class="d-flex w-100 align-items-center">
          <div class="mr-1">
            <b-avatar
              size="35"
              :src="avatarUrl"
              :text="avatarInitials"
            />
          </div>
          <div class="m-0 user-name-wrap">
            <p
              class="m-0 font-weight-bolder user-name-truncate"
              :title="displayName"
            >
              {{ displayName }}
            </p>
            <small>Admin</small>
          </div>
        </div>
      </div>
    </b-dropdown-item>
    <b-dropdown-item
      :to="{ name: 'profile-account-setting' }"
      link-class="d-flex align-items-center user-menu-item"
    >
      <img
        src="/svg/MyProfile.svg"
        alt=""
        class="mr-50 menu-icon"
        width="16"
        height="16"
      >
      <span>My Profile</span>
    </b-dropdown-item>
    <b-dropdown-item
      :to="{ name: 'password-account-setting' }"
      link-class="d-flex align-items-center user-menu-item"
    >
      <img
        src="/svg/ChangePassword.svg"
        alt=""
        class="mr-50 menu-icon"
        width="16"
        height="16"
      >
      <span>Change Password</span>
    </b-dropdown-item>
    <b-dropdown-divider />
    <b-dropdown-item
      :to="{ name: 'pages-pricing' }"
      link-class="d-flex align-items-center user-menu-item"
    >
      <img
        src="/svg/Plans.svg"
        alt=""
        class="mr-50 menu-icon"
        width="16"
        height="16"
      >
      <span>Plans</span>
    </b-dropdown-item>
    <b-dropdown-item :to="{ name: 'pages-help' }" link-class="d-flex align-items-center user-menu-item">
      <img
        src="/svg/Help.svg"
        alt=""
        class="mr-50 menu-icon"
        width="16"
        height="16"
      >
      <span>Help</span>
    </b-dropdown-item>
    <b-dropdown-item :to="{ name: 'pages-faq' }" link-class="d-flex align-items-center user-menu-item">
      <img
        src="/svg/FAQ.svg"
        alt=""
        class="mr-50 menu-icon"
        width="16"
        height="16"
      >
      <span>FAQ</span>
    </b-dropdown-item>
    <b-dropdown-divider />
    <b-dropdown-item link-class="d-flex align-items-center user-menu-item" @click="logout">
      <img
        src="/svg/SignOut.svg"
        alt=""
        class="mr-50 menu-icon"
        width="16"
        height="16"
      >
      <span>Sign Out</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
  BSpinner,
} from 'bootstrap-vue'
import axios from '@/component/axios'
import { teardownAdminWebPush } from '@/plugins/webPush'
import { getUserAvatarUrl, getUserDisplayName, getUserInitials } from '@/utils/userDisplay'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BSpinner,
    BDropdownDivider,
    BAvatar,
  },
  data() {
    return {
      accessToken: localStorage.getItem('accessToken'),
      baseApi: process.env.VUE_APP_APIENDPOINT,
      userData: JSON.parse(localStorage.getItem('userData') || 'null'),
      isSideDataLoading: false,
    }
  },
  computed: {
    displayName() {
      return getUserDisplayName(this.userData)
    },
    avatarUrl() {
      return getUserAvatarUrl(this.userData)
    },
    avatarInitials() {
      return getUserInitials(this.userData)
    },
  },
  mounted() {
    this.refreshProfile()
  },
  methods: {
    async refreshProfile() {
      const id = this.userData?.id
      if (!id || !this.accessToken) return
      this.isSideDataLoading = true
      try {
        const res = await axios({
          method: 'GET',
          url: `${this.baseApi}auth/admin/get-profile/${id}`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.accessToken}`,
          },
        })
        const profile = res?.data?.data
        if (profile) {
          this.userData = { ...this.userData, ...profile }
          localStorage.setItem('userData', JSON.stringify(this.userData))
        }
      } catch (e) {
        // Keep cached localStorage profile when API is unavailable.
      } finally {
        this.isSideDataLoading = false
      }
    },
    async logout() {
      try {
        await axios({
          method: 'GET',
          url: `${this.baseApi}auth/admin/logout`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.accessToken}`,
          },
        })
      } catch (e) {
        // Still clear local session if the API is unreachable or token already invalid.
      } finally {
        teardownAdminWebPush()
        localStorage.clear()
        this.$router.push({ name: 'auth-login' })
      }
    },
  },
}
</script>

<style lang="scss">
.custom-user-dropdown {
  .dropdown-menu {
    width: 265px;
    padding: 0;
    border-radius: 0.5rem;
    overflow: hidden;
  }

  .dropdown-divider {
    margin: 0;
  }

  .user-nav {
    max-width: 140px;
    min-width: 0;
  }

  .user-name-wrap {
    min-width: 0;
    flex: 1 1 auto;
    overflow: hidden;
  }

  .user-name-truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
  }

  .user-profile-head {
    padding: 0.85rem 1rem !important;
  }

  .user-profile-head p {
    font-size: 0.94rem;
    color: #2f2b3d;
  }

  .user-profile-head small {
    color: #6e6b7b;
    font-size: 0.78rem;
  }

  .user-menu-item {
    padding: 0.75rem 1rem !important;
    color: #5e5873 !important;
    font-size: 0.9rem;
  }

  .menu-icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    object-fit: contain;
  }
}
</style>
